import { gql } from '@urql/core';

export const GET_LANGUAGES = gql`
query CmsLanguages {
  cmsLanguages {
    id
    code
    name
  }
}`;

export const GET_PACKAGE = gql`
  query CmsPackage($id: ID!) {
    cmsPackage(id: $id) {
      id
      name
      pages {
        id
        name
        url
        cms_package_id
        elements {
          id
          cms_page_id
          element
          name
          type
          contents {
            id
            content
            cms_language_id
            cms_element_id
          }
        }
      }
    }
  }
`;
